import React from 'react';
import { useStyles } from "./DeliveryTypePriceLockup.style";
import DeliveryTypePriceLockupProperties from "./DeliveryTypePriceLockupProperties";
import clsx from "clsx";
import { PackageDeliveryType } from '../../model/packageDelivery/PackageDeliveryType';

import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';

const DeliveryTypePriceLockup: React.FC<DeliveryTypePriceLockupProperties> = ({
  className = '',
  deliveryType,
  orders,
  totalWeight,
}) => {
  const classes = useStyles();

  const getDeliveryTypeIcon = (type: PackageDeliveryType) => {
    switch (type) {
      case PackageDeliveryType.PLANE:
        return <AirplanemodeActiveIcon className={classes.icon} />;
      case PackageDeliveryType.SHIP:
        return <DirectionsBoatIcon className={classes.icon} />;
      case PackageDeliveryType.EXPRESS:
        return <AccessAlarmsIcon className={classes.icon} />;
      case PackageDeliveryType.SEMI_EXPRESS:
        return <AddAlarmIcon className={classes.icon} />;
      default:
        return null;
    }
  };

  const getDeliveryTypeLabel = (type: PackageDeliveryType) => {
    switch (type) {
      case PackageDeliveryType.PLANE:
        return 'AVIÓN';
      case PackageDeliveryType.SHIP:
        return 'BARCO';
      case PackageDeliveryType.EXPRESS:
        return 'EXPRESS';
      case PackageDeliveryType.SEMI_EXPRESS:
        return 'SEMI-EXPRESS';
      default:
        return '';
    }
  };

  return (
    <div className={clsx(classes.lockup_container, className)}>
      <div className={classes.header}>
        {getDeliveryTypeIcon(deliveryType)}
        <span className={classes.label}>{getDeliveryTypeLabel(deliveryType)}</span>
      </div>
      <div className={classes.weight}>{totalWeight.toFixed(2)} Lbs</div>
      <div className={classes.orders}>{orders} envío{orders > 1 ? 's' : ''}</div>
    </div>
  );
};

export default DeliveryTypePriceLockup;
